<template>
  <div
    id="user-details"
    class="no-shrink"
    :class="{hide: hideDetails}">
    <ContactDetails
      v-if="section === 'info'"/>
    <UserNotes
      v-if="section === 'notes'"/>
    <UserProperties
      v-if="section === 'properties'"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ContactDetails from './ContactDetails';
import UserNotes from './UserNotes';
import UserProperties from './UserProperties';

export default {
  name: 'PanelDetails',
  components: {
    ContactDetails,
    UserNotes,
    UserProperties,
  },
  props: {
    // conversation: {
    //   type: Object,
    //   required: true,
    //   default: () => {},
    // },
  },
  data() {
    return {
      hideDetails: false,
    };
  },
  computed: {
    ...mapGetters({
      section: 'contactDetails/activeSection',
    }),
  },
  watch: {

  },
  mounted() {
    // console.log('mounted');
  },
  beforeDestroy() {
    // console.log('destroyed');
  },
  methods: {
    /**
     * Toggles the column with an animation.
     */
    toggle() {},
    toggler(payload) {
      // console.log('TOGGLING 2222222: ', payload);
      this.hideDetails = !this.hideDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO animation via vue animation so the remove is not cut off. Visible when played in 10% speed
#user-details {
  background-color: $greyUltralight;
  width: $detailsSidebarWidth;
  transition: .1s all;
  overflow: hidden;
  box-shadow: -1px 0 $greyBorderSecondary;
  z-index: 900;

  h3 {
    margin: 18px 15px 15px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.05;
    color: $blackPrimary;
  }

  &.hide {
    width: 0;
  }
}
</style>
